import {
  postMessageQuickCancelAnalyticsEvent,
  readSubscriberCountry,
} from '../../utils/common';

const DEFAULT_REASON_FOR_CANCEL_NAME = 'No Reason Selected';

const getSubscriptionPackageAndType = (
  subscriptionList,
  entitledPlanList,
  currentPlanName,
) => {
  if (!entitledPlanList?.length) {
    return { subscriptionPackage: '', subscriptionType: '' };
  }
  if (entitledPlanList?.length > 1) {
    return { subscriptionPackage: 'Multiple', subscriptionType: 'Multiple' };
  }
  const [entitledPlan] = entitledPlanList || [];
  const findSubscription = (subscriptionList || []).find(
    (item) => entitledPlan?.subscriptionId === item?.Id,
  );
  if (!findSubscription) {
    return { subscriptionPackage: '', subscriptionType: '' };
  }
  const subscriptionPackage = findSubscription?.Items?.[0]?.Product?.Name ?? '';

  const splitPricingPlanName = (pricingPlanName, appSource) => {
    if (appSource?.toLowerCase() !== 'web') {
      return appSource;
    }
    const sliptName = pricingPlanName.split(' ');
    return sliptName?.[1] || '';
  };

  const pricingPlanName =
    currentPlanName || findSubscription?.Items?.[0]?.PricingPlan?.Name || '';

  return {
    subscriptionPackage,
    subscriptionType: splitPricingPlanName(
      pricingPlanName,
      entitledPlan?.appSource,
    ),
  };
};

const quickCancelEventPayload = (
  language,
  currentSubscription,
  entitledPlan,
  currentPlanName = '',
) => {
  const userCountry = readSubscriberCountry();
  const selectedLanguage = language;
  const { subscriptionPackage, subscriptionType } =
    getSubscriptionPackageAndType(
      currentSubscription,
      entitledPlan,
      currentPlanName,
    );

  return {
    subscriptionPackage,
    subscriptionType,
    userCountry,
    selectedLanguage,
  };
};

const getReasonForCancelName = (
  selectedTerminationReason,
  reasonForCancelCodeTable = [],
) => {
  const reasonForCancelCodeBasedOnCodeTable = (
    reasonForCancelCodeTable || []
  ).reduce((all, item) => {
    if (item.Value === selectedTerminationReason) {
      all = item.Name;
    }
    return all;
  }, DEFAULT_REASON_FOR_CANCEL_NAME);
  return reasonForCancelCodeBasedOnCodeTable;
};

export const quickCancelAnalyticEvents = (
  language,
  subscriptionUiModel,
  retrieveEligibilityUiModel,
  isQuickCancel,
  eventName,
  currentPlanName = '',
) => {
  const eventPayload = quickCancelEventPayload(
    language,
    subscriptionUiModel,
    retrieveEligibilityUiModel,
    currentPlanName,
  );
  postMessageQuickCancelAnalyticsEvent(isQuickCancel, eventName, eventPayload);
};

export const quickCancelConfirmedAnalyticEvents = (
  language,
  subscriptionUiModel,
  retrieveEligibilityUiModel,
  isQuickCancel,
  eventName,
  currentPlanName = '',
  reasonForCancelPayload,
) => {
  const eventPayload = quickCancelEventPayload(
    language,
    subscriptionUiModel,
    retrieveEligibilityUiModel,
    currentPlanName,
  );
  const { terminationReasonCode, terminationReasonCodeTable } =
    reasonForCancelPayload;
  const reasonForCancel = getReasonForCancelName(
    terminationReasonCode,
    terminationReasonCodeTable,
  );
  const eventPayloadWithReasonForCancel = {
    ...eventPayload,
    reasonForCancel,
  };
  postMessageQuickCancelAnalyticsEvent(
    isQuickCancel,
    eventName,
    eventPayloadWithReasonForCancel,
  );
};
